/* Katalog teması — ana sayfa etkileşimleri
   Otomatik kaydırma, scroll animasyonu, sekmeler ve arama önerileri. */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Révélation au défilement ---------- */
  function initReveal() {
    var els = document.querySelectorAll('.rt-reveal');
    if (!els.length) return;
    if (reduceMotion || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('rt-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('rt-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Slider héro ---------- */
  function initHero(root) {
    var slides = root.querySelectorAll('.rt-hero__slide');
    var dots = root.querySelectorAll('.rt-hero__dot');
    if (slides.length < 2) return;
    var idx = 0, timer = null;
    var speed = (parseInt(root.dataset.speed, 10) || 5) * 1000;

    function show(i) {
      idx = (i + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle('rt-active', k === idx); });
      dots.forEach(function (d, k) { d.classList.toggle('rt-active', k === idx); });
      var content = slides[idx].querySelector('.rt-hero__content');
      if (content && !reduceMotion) {
        content.style.animation = 'none';
        void content.offsetWidth; /* redémarre l'animation */
        content.style.animation = '';
      }
    }
    function play() {
      if (reduceMotion || root.dataset.autoplay === 'false') return;
      stop();
      timer = setInterval(function () { show(idx + 1); }, speed);
    }
    function stop() { if (timer) clearInterval(timer); }

    dots.forEach(function (d, k) {
      d.addEventListener('click', function () { show(k); play(); });
    });
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', play);

    /* Parmakla yatay kaydırma. Dinleyiciler passive olduğu için dikey
       sayfa kaydırması hiçbir zaman engellenmez; yalnızca yatay hareket
       dikeyden baskın olduğunda slayt değişir. */
    var x0 = null, y0 = null, t0 = 0;
    root.addEventListener('touchstart', function (e) {
      var t = e.changedTouches[0];
      x0 = t.clientX; y0 = t.clientY; t0 = Date.now();
      stop();
    }, { passive: true });
    root.addEventListener('touchend', function (e) {
      var t = e.changedTouches[0];
      if (x0 === null) { play(); return; }
      var dx = t.clientX - x0, dy = t.clientY - y0, dt = Date.now() - t0;
      x0 = null;
      if (dt <= 800 && Math.abs(dx) >= 40 && Math.abs(dx) >= Math.abs(dy) * 1.5) {
        show(idx + (dx < 0 ? 1 : -1));
      }
      play();
    }, { passive: true });

    show(0);
    play();
  }

  /* ---------- Onglets meilleures ventes ---------- */
  function initTabs(root) {
    var tabs = root.querySelectorAll('.rt-tab');
    var panels = root.querySelectorAll('.rt-panel');
    tabs.forEach(function (t) {
      t.addEventListener('click', function () {
        tabs.forEach(function (x) { x.classList.toggle('rt-active', x === t); });
        panels.forEach(function (p) {
          p.classList.toggle('rt-active', p.dataset.panel === t.dataset.tab);
        });
      });
    });
  }

  /* ---------- Recherche prédictive ---------- */
  function initSearch(root) {
    var input = root.querySelector('input[name="q"]');
    var drop = root.querySelector('.rt-search__drop');
    if (!input || !drop) return;
    var debounce = null;
    var fmt;
    try {
      fmt = new Intl.NumberFormat(document.documentElement.lang || 'fr', {
        style: 'currency',
        currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'TRY'
      });
    } catch (e) { fmt = null; }

    function hide() { drop.hidden = true; drop.innerHTML = ''; }

    input.addEventListener('input', function () {
      var q = input.value.trim();
      if (debounce) clearTimeout(debounce);
      if (!q) { hide(); return; }
      debounce = setTimeout(function () {
        var url = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') +
          'search/suggest.json?q=' + encodeURIComponent(q) +
          '&resources[type]=product&resources[limit]=5&resources[options][fields]=title,product_type,variants.title';
        fetch(url)
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var products = (data.resources && data.resources.results && data.resources.results.products) || [];
            drop.innerHTML = '';
            if (!products.length) {
              var empty = document.createElement('div');
              empty.className = 'rt-search__empty';
              empty.textContent = 'Aucun résultat trouvé';
              drop.appendChild(empty);
            } else {
              products.forEach(function (p) {
                var a = document.createElement('a');
                a.className = 'rt-search__item';
                a.href = p.url;
                var n = document.createElement('span');
                n.className = 'rt-search__item-name';
                n.textContent = p.title;
                var pr = document.createElement('span');
                pr.className = 'rt-search__item-price';
                var val = parseFloat(p.price);
                pr.textContent = fmt && !isNaN(val) ? fmt.format(val) : (p.price || '');
                a.appendChild(n); a.appendChild(pr);
                drop.appendChild(a);
              });
            }
            drop.hidden = false;
          })
          .catch(hide);
      }, 220);
    });

    document.addEventListener('click', function (e) {
      if (!root.contains(e.target)) hide();
    });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') hide();
    });
  }

  /* ---------- Menu mobile (tiroir latéral) ---------- */
  function initNav(nav) {
    if (nav.dataset.rtNavReady) return;
    nav.dataset.rtNavReady = '1';

    var panel = nav.querySelector('.rt-nav__panel');
    var toggles = document.querySelectorAll('[data-rt-nav-toggle]');
    var lastFocus = null;

    function isOpen() {
      return nav.classList.contains('rt-open');
    }

    function open() {
      if (isOpen()) return;
      lastFocus = document.activeElement;
      nav.classList.add('rt-open');
      nav.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('rt-nav-lock');
      toggles.forEach(function (t) { t.setAttribute('aria-expanded', 'true'); });
      var first = nav.querySelector('.rt-nav__close');
      if (first) first.focus();
    }

    function close() {
      if (!isOpen()) return;
      nav.classList.remove('rt-open');
      nav.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('rt-nav-lock');
      toggles.forEach(function (t) { t.setAttribute('aria-expanded', 'false'); });
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    toggles.forEach(function (t) {
      t.addEventListener('click', function () {
        isOpen() ? close() : open();
      });
    });

    nav.querySelectorAll('[data-rt-nav-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });

    // un lien cliqué ferme le tiroir
    nav.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', close);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && isOpen()) close();
    });

    // le tiroir n'existe qu'en mobile : on ferme si on repasse en desktop
    window.addEventListener('resize', function () {
      if (window.innerWidth > 749 && isOpen()) close();
    });
  }

  /* ---------- Başa dön butonu ----------
     Bu temada kaydırma kabı ekran genişliğine göre değişir: masaüstünde
     base.css html/body'yi kilitleyip .page-wrapper'ı kaydırır, mobilde
     sayfanın kendisi kayar. Her iki durumu da desteklemek gerekiyor. */
  function scrollHost() {
    var pw = document.querySelector('.page-wrapper');
    if (pw && pw.scrollHeight > pw.clientHeight + 1) {
      var ov = getComputedStyle(pw).overflowY;
      if (ov === 'auto' || ov === 'scroll') return pw;
    }
    return null; // null => pencere kayar
  }

  function initToTop() {
    if (document.querySelector('.rt-totop')) return;

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'rt-totop';
    btn.setAttribute('aria-label', 'Sayfanın başına dön');
    btn.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 19V5M5 12l7-7 7 7"></path></svg>';
    document.body.appendChild(btn);

    var shown = false, ticking = false;

    function currentTop() {
      var host = scrollHost();
      return host ? host.scrollTop : (window.pageYOffset || document.documentElement.scrollTop || 0);
    }

    function update() {
      ticking = false;
      var threshold = Math.max(600, window.innerHeight * 0.9);
      var should = currentTop() > threshold;
      if (should !== shown) {
        shown = should;
        btn.classList.toggle('rt-in', shown);
      }
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }

    // Hangi kabın kaydığı ekran genişliğine göre değiştiği için ikisini de dinle
    window.addEventListener('scroll', onScroll, { passive: true });
    var pw = document.querySelector('.page-wrapper');
    if (pw) pw.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });

    btn.addEventListener('click', function () {
      var host = scrollHost();
      var opts = { top: 0, behavior: reduceMotion ? 'auto' : 'smooth' };
      if (host) host.scrollTo(opts);
      else window.scrollTo(opts);
      // Klavye kullanıcısı sayfanın başında kalsın
      var first = document.querySelector('.rt-header__logo');
      if (first && first.focus) first.focus({ preventScroll: true });
    });

    update();
  }

  /* ---------- Init ---------- */
  function init() {
    initToTop();
    initReveal();
    document.querySelectorAll('[data-rt-hero]').forEach(initHero);
    document.querySelectorAll('[data-rt-tabs]').forEach(initTabs);
    document.querySelectorAll('[data-rt-search]').forEach(initSearch);
    document.querySelectorAll('[data-rt-nav]').forEach(initNav);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Ré-init dans l'éditeur de thème */
  document.addEventListener('shopify:section:load', init);
})();
